import {
  ChangelogTypeEnum,
  Factory,
  QuickFactory,
} from '@infodata-group/inf-commons';
import { DtoWebtoolsChangelogEntryInterface } from '../interface/dto-webtools-changelog-entry.interface';
import { WebtoolsChangelogEntry } from '../model/webtools-changelog-entry';
import dayjs from 'dayjs';

export class WebtoolsChangelogEntryFactory
  extends QuickFactory
  implements Factory<WebtoolsChangelogEntry>
{
  build(o: DtoWebtoolsChangelogEntryInterface): WebtoolsChangelogEntry {
    const entry: WebtoolsChangelogEntry = new WebtoolsChangelogEntry(
      o.id,
      o.title,
      o.message,
      ChangelogTypeEnum[o.type],
    );
    this.generateProperty(entry, o);
    entry.date = dayjs(o.date, 'DD/MM/YYYY - HH:mm').toDate();
    entry.createdBy = o.createdBy;
    entry.updatedAt = o.updatedAt
      ? dayjs(o.updatedAt, 'DD/MM/YYYY - HH:mm').toDate()
      : null;
    entry.updatedBy = o.updatedBy ? o.updatedBy : null;

    return entry;
  }

  getApi(): string {
    return 'entries';
  }
}
